import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
import { WalletService }  from '../../../../services/wallet.services';

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'notifications-screen',
    templateUrl:'notifications-screen-component.html'
})
export class NotificationsScreenComponent implements OnInit, OnDestroy{

  public admin=false;
  public notifications;
  public constructor( private _router : Router,public walletService: WalletService, public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnDestroy() : any {
  }

  public ngOnInit(): any {
    this.notifications=[];
    let date=new Date();
    let milis=date.getTime();
    this._companyService.getUserNotifications(this._appData.instagramUser).limitToLast(50).once("value",(snap)=>{
      let us=snap.val(); //objects correspond to users
      for (let prop in us){
        if ((milis-us[prop].time)<60*60*24*1000){
          us[prop].when=this.longToDate(us[prop].time)
          this.notifications.unshift(us[prop])
  
        }
      }
      })

  }
  public transferItens(contact){
    let quantity=this._appData.toTransferList.length;
    Swal.fire({
      text:'Você deseja transferir para '+contact.full_name+' os '+quantity+' itens?',
      title:'Transferência de itens',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.dismiss=='backdrop') {}
      else if (result.dismiss=='close') {}
      else if (result.dismiss=='cancel'){}
      else{
        let sample=this._appData.toTransferList[0];
        let token=sample.tokenId;
        this.walletService.makeTokenTransfer(sample.owner,'user',contact.uid,'user',token,quantity,null,null,null,null,null).subscribe(res=>{
          if (res.status==200){     
            let signature=res.json();
            this._appData.toTransferList.forEach(it=>{
              it.owner=contact.uid
              it.lastTransaction=signature;
              this._companyService.getUserRoomItemRef(it.room.toString()).doc(it.objectId).set(it).then(c=>{
                quantity=quantity-1;
                if (quantity==0){
                  this._appData.toTransferList=null;
                }
              }

              )
            })
          }
          else{
            Swal.fire({title:'Falha',text:'Erro na transferencia'})
          }
        },err=>{
          Swal.fire({title:'Falha',text:'Erro na transferencia'})
        })

      }
    });       
  
  }
  public doSearch(event: any){
    /*let input=$("#searchInput").val();
    this.contacts=[];
    let upper=input.toUpperCase();
    this._companyService.getContacts(this._appData.instagramUser).where("full_name", ">=", upper).orderBy("full_name", "asc").get().then(snap=>{
      snap.forEach( userSnap =>{
        let user=userSnap.data();

        if (!user.profile_picture){
          user.profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.png"
        }       
        this.contacts.push(user)
      })
    })
*/
  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }


  public openChat(contact){
    this._appData.talkTo={uid:contact.senderUid,full_name:contact.senderName,profile_picture:contact.senderThumbnail};
    this._appData.cellScreen='chat'
    setTimeout(()=>{
      $('#cellChatReload').click()
    },1000)
  }
  public openConference(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_3'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_4'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_21'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_22'),"newCellJitsi","",false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_20')
        });
      }
    });       
  }
  public kick(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_5'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_6')+contact.full_name+'?',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},this.translate.instant('CONTACT_SCREEN_COMPONENT_23'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_24'),'kick',null,null)
      }
    })

  }
  public ban(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    let admin=false;
    if (this._appData.event.admins){
      this._appData.event.admins.forEach((val)=>{
        if (val==this._appData.instagramUser.uid){
          admin=true;
          this._appData.instagramUser.vip=true;
        }
      }) 
    }
    if (admin){
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_8')+contact.full_name+'',
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCancelButton: true,
        showCloseButton: true,
        preConfirm: () => {
          this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,{uid:contact.uid,full_name:contact.full_name},this.translate.instant('CONTACT_SCREEN_COMPONENT_25'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_26'),'ban',null,null)
        }
      })  
    }
    else{
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_7'),
        text:this.translate.instant('CONTACT_SCREEN_COMPONENT_10')
      })  

    }

  }
  public yoink(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_12'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_11')+contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_9'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,'Yoink',this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_13'),'Yoink',0,null)
      }

    })

  }
  public trade(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    this._appData.friendOnEvent=contact;
    $("#tradeModal").modal("show");  
    $("#tradeModalClick").click();

  }
  public goto(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    Swal.fire({
      title:this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
      text:this.translate.instant('CONTACT_SCREEN_COMPONENT_15'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,contact,this.translate.instant('CONTACT_SCREEN_COMPONENT_18'),this._appData.instagramUser.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_19'),"newCellTeleport",this._appData.room.id,false)
        Swal.fire({
          title:this.translate.instant('CONTACT_SCREEN_COMPONENT_16'),
          message: contact.full_name+this.translate.instant('CONTACT_SCREEN_COMPONENT_17')
        });
      }
    });       
  }
  public longToDate(number){
    let date=new Date(number)
    let day=date.getDate();
    let month=date.getMonth()+1;
    let monthStr=month.toString();
    if (monthStr.length==1) monthStr='0'+monthStr;
    let year=date.getFullYear();
    let hour=date.getHours();
    let hourStr=hour.toString();
    if (hourStr.length==1) hourStr='0'+hourStr;
    let minute=date.getMinutes()
    let minuteStr=minute.toString();
    if (minuteStr.length==1) minuteStr='0'+minuteStr;

    return day+'/'+monthStr+'/'+year+' '+hourStr+':'+minuteStr
  } 

  public seeProfile(notification){
    let contact={uid:notification.senderUid,full_name:notification.senderName,profile_picture:notification.senderThumbnail}
    this._appData.talkTo=contact;
    this._appData.cellScreen='profile'
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/notifications-screen/notifications-screen-component.ts